import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Reset
 *
 * Physical Architecture "Reset" module — wraps the self-contained HTML at
 * /modules/reset.html in an iframe with a single floating exit button so
 * the user can return to the Physical Architecture choice screen.
 *
 * On mount we fire `/api/reset/log` (best-effort) so the afternoon push
 * nudge knows to skip users who already reset today.
 */
const Reset = ({ onExit }) => {
  useEffect(() => {
    const token = localStorage.getItem('gntl_token');
    if (!token || !API_URL) return;
    fetch(`${API_URL}/api/reset/log`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {});
  }, []);

  return (
    <div
      className="fixed inset-0 bg-[#1A1A1A] z-40 flex flex-col"
      data-testid="reset-module"
    >
      <button
        onClick={onExit}
        aria-label="Exit Reset"
        data-testid="reset-exit"
        className="absolute top-safe-3 right-3 z-50 w-9 h-9 rounded-full bg-[#1A1A1A]/80 border border-[#F5F2EB]/15 text-[#F5F2EB]/70 hover:text-[#F5F2EB] hover:border-[#F5F2EB]/35 backdrop-blur flex items-center justify-center transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
      <iframe
        src="/modules/reset.html"
        title="Reset"
        className="flex-1 w-full border-0"
        allow="microphone; autoplay; fullscreen; encrypted-media"
      />
    </div>
  );
};

export default Reset;
